import { config } from "shared/data";

import type { ViewabilityEventPayload } from "./types";

export async function trackViewabilityEvents(items: ViewabilityEventPayload[]) {
  if (items.length === 0) return;

  const response = await fetch(config.advertisement.viewabilityService.url, {
    body: JSON.stringify(items),
    headers: {
      apiKey: config.advertisement.viewabilityService.apiKey,
      "Content-Type": "application/json",
    },
    keepalive: true,
    method: "POST",
  });
  return response;
}
